
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9kLXx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18373519e9b8bb8d789f8e6cb8a6aee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cbb2f0173cd9474$var$_react = $6cbb2f0173cd9474$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $6cbb2f0173cd9474$var$_baseNew = $6cbb2f0173cd9474$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6cbb2f0173cd9474$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PriorityTrivial".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for trivial work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6cbb2f0173cd9474$var$PriorityTrivialIcon = (props)=>/*#__PURE__*/ $6cbb2f0173cd9474$var$_react.default.createElement($6cbb2f0173cd9474$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<circle cx="8" cy="8" r="7.25" stroke="currentcolor" stroke-width="1.5"/>`
    }, props));
$6cbb2f0173cd9474$var$PriorityTrivialIcon.displayName = 'PriorityTrivialIcon';
var $6cbb2f0173cd9474$var$_default = module.exports.default = $6cbb2f0173cd9474$var$PriorityTrivialIcon;

});


//# sourceMappingURL=priority-trivial.51d507dd.js.map
